import * as React from "react"
import { alankaramDataAtom } from "../state";
import { useRecoilValue } from "recoil";

const AlankaramLogo = (props: React.ImgHTMLAttributes<HTMLImageElement>) => {
  const alankaramData = useRecoilValue(alankaramDataAtom);
  return (
    <img
      src={alankaramData?.logo}
      alt={`${alankaramData?.companyName} Logo`}
      {...props}
    />
  )
}

export default AlankaramLogo